import React from 'react'
import { Alert, Box, Button, Card, CardContent, LinearProgress, TextField, Typography, useMediaQuery } from '@mui/material'
import LoginRoundedIcon from '@mui/icons-material/LoginRounded'
import { useSuiteSession } from '../../context/SuiteSessionContext'
import QualityProductionLogo from '../../media/CALIDAD_PRODUCCION.png'

const apiMessage = (error, fallback) => (
  error?.payload?.message ||
  error?.message ||
  fallback
)

export const LoginPage = () => {
  const isPhone = useMediaQuery('(max-width:599.95px)')
  const { error, login, status } = useSuiteSession()
  const [form, setForm] = React.useState({
    login: '',
    password: '',
  })
  const [message, setMessage] = React.useState(null)
  const loading = status === 'loading'

  const handleChange = (event) => {
    const { name, value } = event.target
    setForm((currentForm) => ({
      ...currentForm,
      [name]: value,
    }))
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setMessage(null)

    try {
      await login(form)
    } catch (loginError) {
      setMessage(apiMessage(loginError, 'No se ha podido iniciar sesion.'))
    }
  }

  return (
    <Box className="quality-login-page">
      <Card className="quality-login-card" elevation={0}>
        {loading ? <LinearProgress /> : null}
        <CardContent>
          <Box className="quality-login-brand">
            <img src={QualityProductionLogo} alt="Calidad en produccion" />
            <Typography variant="h4">Calidad en produccion</Typography>
            <Typography>Inicia sesion para conectar con Suite API y registrar controles.</Typography>
          </Box>

          {(message || error?.status === 401) ? (
            <Alert severity="error" className="quality-login-alert">
              {message || 'Introduce tus credenciales para continuar.'}
            </Alert>
          ) : null}

          <Box component="form" className="quality-login-form" onSubmit={handleSubmit}>
            <TextField
              autoFocus={!isPhone}
              fullWidth
              label="Usuario"
              name="login"
              value={form.login}
              onChange={handleChange}
              disabled={loading}
              autoComplete="username"
            />
            <TextField
              fullWidth
              label="Contrasena"
              name="password"
              type="password"
              value={form.password}
              onChange={handleChange}
              disabled={loading}
              autoComplete="current-password"
            />
            <Button
              className="quality-primary-action"
              type="submit"
              variant="contained"
              startIcon={<LoginRoundedIcon />}
              disabled={loading || !form.login || !form.password}
            >
              Entrar
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}
